import { Props } from './types';

const COLORS: NonNullable<Props['color']>[] = [
  'error',
  'primary',
  'success',
  'warning',
];

const SIZES: NonNullable<Props['size']>[] = ['small', 'medium'];

const DEFAULT_SIZE: (typeof SIZES)[number] = 'medium';

const CONFIG = {
  COLORS,
  SIZES,
  DEFAULT_SIZE,
} as const;

export default CONFIG;
